export default __webpack_public_path__ + "b3bf73e3dd1690b3beab98d39965bff8.otf";